<div>
  <div
    bsModal
    #childModal="bs-modal"
    class="modal fade custom-modal"
    tabindex="-1"
    role="dialog"
    [config]="{ backdrop: true }">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <span>{{ groups.length > 0 ? 'Choose the target group' : 'Add new group' }}</span>
          <img src="assets/img/x.svg" (click)="cancel()" alt="" />
        </div>
        <div class="modal-body">
          <span *ngIf="groups.length > 0" class="option-label">Enter Group Name </span>
          <div class="form-group">
            <div class="form-label">Group Name</div>
            <div class="form-input-container" [ngClass]="{ 'invalid-input': hasGroupNameError() }">
              <input type="text" class="form-input" [formControl]="groupNameControl" placeholder="Type here" />
            </div>
            <span *ngIf="hasGroupNameError()" class="text-danger"> This group already exists </span>
          </div>
          <div *ngIf="groups.length > 0" class="group-selection">
            <hr />
            <span class="option-label group-selection-label">Choose the Target Group...</span>
            <ul class="options">
              <li *ngFor="let g of groups">
                <label class="radio">
                  <input type="radio" [formControl]="chosenControl" [value]="g" name="target-group" />
                  <span class="radio-label">{{ g.name }}</span>
                </label>
              </li>
            </ul>
          </div>
        </div>
        <div class="modal-footer">
          <div>
            <button *ngIf="groups.length == 0 && canApplyTemplate" class="btn-template" (click)="applyTemplate()">
              Choose a Template
            </button>
          </div>

          <div class="footer-actions">
            <button class="btn-cancel" (click)="cancel()">Cancel</button>
            <button class="btn-save" [disabled]="groupNameControl.invalid && chosenControl.invalid" (click)="save()">
              {{ canApplyTemplate ? 'Create group' : 'Save' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
